<template>
  <div class="platform-select">
    <button @click="openMenuPlatforms">
      <i class="icon-nav-app" />
    </button>

    <ul
      class="platform-select__platforms-list"
      v-if="showPlatforms"
      @mouseleave="mouseLeaveMenuPlatforms"
    >
      <p>
        Plataformas
        <i class="icon-nav-app" />
      </p>
      <template v-for="(platform, index) in apps" :key="index">
        <li @click="platform.action">{{ platform.label }}</li>
      </template>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import { useStore } from "vuex";
import getAccount from "@/components/atomic/organisms/navMenuNave/account";
import {
  IAplication,
  IApplicationList,
  IYourApplications,
} from "@/common/services/users/interfaceUsers";

export default defineComponent({
  name: "PlatformSelect",

  setup() {
    const showPlatforms = ref(false);
    const store = useStore();
    const { account } = getAccount();

    const openMenuPlatforms = () => {
      window.removeEventListener("click", openMenuPlatforms, false);

      showPlatforms.value = !showPlatforms.value;
    };

    const mouseLeaveMenuPlatforms = () => {
      window.addEventListener("click", openMenuPlatforms, false);
    };

    const goToApp = (account: string, app: IAplication) => {
      const redirect = app.redirect || "";

      const url = redirect
        .replace("${casToken}", store.getters["token/token"])
        .replace("${accountId}", account);

      window.open(url, "_blank");
    };

    const applications = computed((): IYourApplications => {
      let yourApplications: IYourApplications = {};
      let code = account.value.code?.customerId || "";
      let list: IApplicationList[] = [];

      account.value.applications.map((application: IAplication) => {
        if (application.name == "All in") {
          list.push({
            label: application.name,
            action: () => goToApp(account.value.account || "", application),
          });
        }

        yourApplications[code] = list;
      });

      return yourApplications;
    });

    const apps = computed(() => {
      return applications.value[account.value.code.customerId] || [];
    });

    return {
      showPlatforms,
      apps,
      openMenuPlatforms,
      mouseLeaveMenuPlatforms,
    };
  },
});
</script>

<style lang="scss">
.platform-select {
  position: relative;
  display: flex;

  > button {
    border: none;
    background: transparent;
    display: flex;
    padding: 0;

    > i {
      color: var(--insights-color-16);
      font-size: toRem(19px);
    }
  }

  &__platforms-list {
    list-style: none;
    position: absolute;
    top: 0;
    right: 0;
    background: var(--insights-color-2);
    width: toRem(170px);
    padding: 1.1rem 1.3rem;
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    color: #989898;
    font-size: toRem(15px);

    p {
      text-transform: uppercase;
      font-size: 0.8rem;
      color: var(--insights-color-16);
      cursor: default;
      display: flex;
      width: 100%;
      justify-content: space-between;
      font-family: "text-medium";

      > i {
        color: var(--insights-color-16);
        font-size: toRem(19px);
      }
    }

    li {
      margin-bottom: toRem(11px);
      cursor: pointer;

      &:hover {
        color: var(--insights-color-1);
      }

      &:last-child {
        margin-bottom: none;
      }
    }
  }
}
</style>
